import React from 'react';
import { ExclamationTriangleIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export default function ErrorPage(props) {
  console.log(props.emessage);
  console.log(props.nodatafound);
  
  return (
    <div className="w-full px-4 py-8 md:py-12 min-h-[60vh] flex items-center justify-center">
      <div className="max-w-lg w-full mx-auto">
        <div className="bg-gradient-to-br from-white via-primary-50/30 to-primary-100/20 rounded-3xl shadow-2xl border-2 border-primary-200/50 p-6 md:p-10 text-center backdrop-blur-sm">
          {/* Icon with gradient background */}
          <div className="flex justify-center mb-6 md:mb-8">
            <div className="relative">
              {/* Animated gradient ring */}
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-primary-400 via-primary-500 to-primary-600 opacity-20 animate-pulse blur-xl"></div>
              <div className="relative rounded-full bg-gradient-to-br from-primary-100 to-primary-200 p-4 md:p-5 shadow-lg border-2 border-primary-300/50">
                {props.nodatafound ? (
                  <MagnifyingGlassIcon className="h-12 w-12 md:h-16 md:w-16 text-primary-600" />
                ) : (
                  <ExclamationTriangleIcon className="h-12 w-12 md:h-16 md:w-16 text-primary-600" />
                )}
              </div>
            </div>
          </div>
          
          {props.nodatafound && (
            <div className="space-y-3 md:space-y-5">
              <h2 className="text-2xl md:text-4xl font-bold text-primary-900 font-nunito leading-tight">
                No Data Found
              </h2>
              <p className="text-base md:text-lg text-gray-700 font-nunito leading-relaxed px-2">
                No records found for the selected combination. Please review your search parameters and try again.
              </p>
            </div>
          )}
          
          {props.emessage && (
            <div className="space-y-3 md:space-y-5">
              <h2 className="text-2xl md:text-4xl font-bold text-primary-900 font-nunito leading-tight">
                Oops! Something Went Wrong
              </h2>
              <p className="text-base md:text-lg text-gray-700 font-nunito leading-relaxed px-2">
                Something went wrong when fetching records. Please try again later.
              </p>
              <div className="mt-6 p-4 md:p-5 bg-gradient-to-r from-warning-50 to-warning-100/50 rounded-xl border border-warning-200/60 shadow-inner">
                <p className="text-xs md:text-sm text-warning-800 font-nunito font-semibold break-words leading-relaxed">
                  {props.emessage}
                </p>
              </div>
            </div>
          )}
          
          {/* Decorative elements with brand colors */}
          <div className="mt-8 md:mt-10 flex justify-center items-center space-x-3">
            <div className="h-3 w-3 bg-primary-300 rounded-full animate-pulse shadow-md"></div>
            <div className="h-3 w-3 bg-primary-400 rounded-full animate-pulse shadow-md" style={{ animationDelay: '0.2s' }}></div>
            <div className="h-3 w-3 bg-primary-500 rounded-full animate-pulse shadow-md" style={{ animationDelay: '0.4s' }}></div>
            <div className="h-3 w-3 bg-primary-400 rounded-full animate-pulse shadow-md" style={{ animationDelay: '0.6s' }}></div>
            <div className="h-3 w-3 bg-primary-300 rounded-full animate-pulse shadow-md" style={{ animationDelay: '0.8s' }}></div>
          </div>
          
          {/* Subtle bottom accent */}
          <div className="mt-6 md:mt-8 h-1 w-24 mx-auto bg-gradient-to-r from-transparent via-primary-400 to-transparent rounded-full"></div>
        </div>
      </div>
    </div>
  );
}




